import {
  collection,
  doc,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import { TableName } from "../constants/tableName";

export class SocialMediaController {
  static TABLE_NAME = TableName.SOCIAL_MEDIA;

  static getAll = ({ resolve, reject }) => {
    let errorMessage =
      "Unable to get all the social media details.\nPlease contact administrator for assistance.";
    getDocs(collection(db, this.TABLE_NAME))
      .then((data) => {
        console.debug(data);
        resolve(data);
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static add = ({ parameters, resolve, reject }) => {
    let errorMessage =
      "Unable to create new social media details.\nPlease contact administrator for assistance.";
    addDoc(collection(db, this.TABLE_NAME), parameters)
      .then(() => {
        resolve("New social media details added to firebase successfully.");
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static update = ({ parameters, resolve, reject }) => {
    let errorMessage =
      "Unable to update the selected social media details.\nPlease contact administrator for assistance.";
    updateDoc(doc(db, this.TABLE_NAME, parameters.id), parameters)
      .then(() => {
        resolve("Social media details updated to firebase successfully.");
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static deleteAll = ({ idList, resolve, reject }) => {
    let errorMessage =
      "Unable to delete all the social media details.\nPlease contact administrator for assistance.";
    const deletePromises = idList.map((id) => {
      return deleteDoc(doc(db, this.TABLE_NAME, id)).catch((error) => {
        console.debug(error.message);
        throw error;
      });
    });
    Promise.all(deletePromises)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static errorHandling = ({ errorMessage, error }) => {
    switch (error.code) {
      case "permission-denied":
        errorMessage = "You are not authorised for this action.";
        break;
      default:
        break;
    }
    console.debug(error.message);
    return errorMessage;
  };
}
